import { css } from "styled-components"

// Instead of subtitle font size being determined by video width (layout nightmare),
// Fix the font size with these.

export const desktopSubtitlesFont = css`
  // Everything except Firefox
  > ::-webkit-media-text-track-display,
    // Firefox
  > ::cue {
    font-size: 1.57rem;
  }
`

export const mobileSubtitlesFont = css`
  // Everything except Firefox
  > ::-webkit-media-text-track-display,
  // Firefox
  > ::cue {
    font-size: 1.14rem;
  }
`
